import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { supabase } from "@/integrations/supabase/client";

interface ClinicianNotificationsProps {
  clinicianId: string;
}

export function ClinicianNotifications({ clinicianId }: ClinicianNotificationsProps) {
  const [notifications, setNotifications] = useState<any[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!clinicianId) return;
    const fetchNotifications = async () => {
      const { data } = await supabase
        .from('clinician_notifications')
        .select('*')
        .eq('clinician_id', clinicianId)
        .order('created_at', { ascending: false })
        .limit(10);
      setNotifications(data || []);
      setUnreadCount(data?.filter(n => !n.read_at).length || 0);
    };
    fetchNotifications();
  }, [clinicianId]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-destructive text-[10px] flex items-center justify-center text-destructive-foreground">
              {unreadCount}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="end">
        <div className="space-y-2">
          <h4 className="font-medium">Notifications</h4>
          {notifications.length === 0 ? (
            <p className="text-sm text-muted-foreground">No notifications</p>
          ) : (
            notifications.slice(0, 5).map(n => (
              <div key={n.id} className={`p-2 rounded text-sm ${!n.read_at ? 'bg-primary/10' : ''}`}>
                <p className="font-medium">{n.title}</p>
                <p className="text-muted-foreground text-xs">{n.message}</p>
              </div>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
